// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ConditionalFormattingConditionType.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { getOr } from 'lodash/fp';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import DropDown from 'share/components/controls/Izenda.DropDown';
import conditionalFormattingUtils from './Izenda.ConditionalFormattingUtils';

@observer
class ConditionalFormattingConditionType extends Component { 
  constructor(props){
    super(props);
  }

  render(){
    const {props: {localization, condition, isAdditionalCondition}} = this;

    const conditionFieldName = getOr('', 'conditionField.name', condition);
    if(conditionFieldName === '')
      return null;

    const conditionFieldDataType = getOr('', 'conditionField.type', condition);
    const conditionTypes = conditionalFormattingUtils.getConditionTypesByFieldType(conditionFieldDataType, isAdditionalCondition); 

    const onTypeChange = (newType) => {
      condition.setType(newType.value);
    };

    return (
      <GridLayout.Row>
        <GridLayout.Col className="u_controlHeight" cols={3}>{localization.getText('CONDITIONAL_FORMATTING_LABEL_CONDITION_TYPE')}</GridLayout.Col>
        <GridLayout.Col cols={9}>
          <DropDown options={conditionTypes} value={condition.type} onChange={onTypeChange} valueField="value" labelField="title"/>
        </GridLayout.Col>
      </GridLayout.Row>
    );
  }
}

export default ConditionalFormattingConditionType;


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ConditionalFormatting/Izenda.ConditionalFormattingConditionType.jsx